import { Entity } from '@loctypes'

export const getRootElement = (entity: Entity): Element => {
  let appScript
  const requiredSelectors = document.querySelectorAll(`script[src*="${entity}.js"]`)

  // больше для деббаг нужно
  if (requiredSelectors) {
    appScript = requiredSelectors[requiredSelectors.length - 1]
  }

  // кастомный селектор
  if (appScript?.dataset.selector) {
    const element = document.querySelector(appScript!.dataset.selector)

    if (!element) {
      throw new Error(
        `could not find a node with a ${appScript!.dataset} selector that you specified in the [data-selector]`
      )
    }

    return element
  }

  // обычный селектор
  const usual = document.querySelector('#flomni')

  if (!usual) {
    throw new Error(`could not find a node with a #flomni selector`)
  }

  return usual
}
